<p-dialog appDialogoPadrao="pi pi-envelope" [(visible)]="visible" [dismissableMask]="true" [style]="{ width: '60rem', maxWidth: '95vw' }" [showHeader]="false" (onHide)="onCancel()" [maximizable]="true" styleClass="compose-dialog">
    <div class="compose-container">
        <!-- Custom Header -->
        <div class="custom-header">
            <div class="header-left">
                <button pButton icon="pi pi-angle-left" class="p-button-text p-button-secondary back-btn" (click)="onCancel()"></button>
                <p-avatar [image]="remetente.avatar" shape="circle" size="large"></p-avatar>
                <div class="sender-info">
                    <div class="sender-name">{{ remetente.nome }}</div>
                    <div class="sender-to">To: {{ originalMessage.to }}</div>
                </div>
            </div>
            <div class="header-right">
                <span class="date">{{ originalMessage.date }}</span>
                <button pButton icon="pi pi-arrow-right" class="p-button-text p-button-secondary action-btn" style="transform: rotate(-45deg)"></button>
                <button pButton icon="pi pi-ellipsis-v" class="p-button-text p-button-secondary action-btn"></button>
            </div>
        </div>

        <!-- Content Card -->
        <div class="content-card">
            <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 1rem">
                <h2 class="subject" style="margin: 0">{{ messageTitle || originalMessage.subject }}</h2>
                <button pButton label="Visualizar Anexo" icon="pi pi-eye" class="p-button-text p-button-sm" (click)="visualizarAnexo()"></button>
            </div>
            <div class="message-body">
                <p>{{ originalMessage.content }}</p>
            </div>

            <!-- Editor Section -->
            <div class="editor-wrapper">
                <p-editor [(ngModel)]="emailData.content" [style]="{ height: '200px' }" styleClass="custom-editor">
                    <ng-template pTemplate="header">
                        <span class="ql-formats">
                            <select class="ql-header">
                                <option value="">Normal</option>
                                <option value="1">Heading 1</option>
                                <option value="2">Heading 2</option>
                            </select>
                            <select class="ql-font">
                                <option selected>Sans Serif</option>
                                <option value="serif">Serif</option>
                                <option value="monospace">Monospace</option>
                            </select>
                        </span>
                        <span class="ql-formats">
                            <button class="ql-bold"></button>
                            <button class="ql-italic"></button>
                            <button class="ql-underline"></button>
                        </span>
                        <span class="ql-formats">
                            <button class="ql-color"></button>
                            <button class="ql-background"></button>
                        </span>
                        <span class="ql-formats">
                            <button class="ql-list" value="ordered"></button>
                            <button class="ql-list" value="bullet"></button>
                            <button class="ql-align"></button>
                        </span>
                        <span class="ql-formats">
                            <button class="ql-link"></button>
                            <button class="ql-image"></button>
                            <button class="ql-code-block"></button>
                            <button class="ql-clean"></button>
                        </span>
                    </ng-template>
                </p-editor>

                <div class="editor-footer">
                    <input #fileInput type="file" multiple (change)="onFilesSelected($event)" style="display: none" />
                    <div class="footer-buttons">
                        <button pButton icon="pi pi-image" class="p-button-outlined p-button-secondary icon-btn" (click)="fileInput.click()"></button>
                        <button pButton icon="pi pi-paperclip" class="p-button-outlined p-button-secondary icon-btn" (click)="fileInput.click()"></button>
                        <button pButton label="Enviar" icon="pi pi-send" class="p-button-primary send-btn" (click)="onSendMessage()"></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</p-dialog>
